import Paragraph from '../Paragraph/Paragraph'
import classes from './ClickableArea.module.scss'
import {
  useEffect,
  useRef,
  useState
} from 'react'
import type { ReactNode } from 'react'

export interface Props {
  placeholder: string
  onClick: () => void
  children: ReactNode
}

const ClickableArea = ({
  children,
  placeholder,
  onClick
}: Props) => {
  const divRef = useRef<HTMLDivElement>(null)
  const [size, setSize] = useState({})

  useEffect(() => {
    if (divRef.current === null) return

    setSize({
      height: divRef.current.offsetHeight,
      width: divRef.current.offsetWidth
    })
  }, [])

  return (
    <div
      aria-hidden
      className={classes.ClickableArea}
      onClick={onClick}
    >
      <div
        className={classes.PlaceholderHide}
        style={size}
      />
      <div className={classes.SecondaryStyle}>
        <Paragraph>
          <strong>
            {placeholder}
          </strong>
        </Paragraph>
      </div>
      <div
        ref={divRef}
        style={size}
      >
        {children}
      </div>
    </div>
  )
}

export default ClickableArea
